import axios from "axios";
import { getSearchTextParts } from "functions/getSearchTextParts";
import { ITlfIndexReturn } from "../hierarchy/loadHierarchyTlfs";
import { processAxiosError } from "../processAxiosError";
import { TlfItemIndexReadDto } from "./TlfItemIndexReadDto";

/**
 * Search across all TLFs using the provided search text.
 *
 * @param backEndUrl - Base backend URL
 * @param searchText - The text to search for
 * @param controller - AbortController for cancelling the request
 * @returns Matching TLF index entries in iTlfIndexReturn
 */
export const searchAllTlfs = async (
  backEndUrl: string,
  searchText: string,
  controller: AbortController,
): Promise<ITlfIndexReturn> => {
  const url = new URL(`${backEndUrl}TlfItems/Search`);
  // Get data
  try {
    const searchTextParts = getSearchTextParts(searchText);
    searchTextParts.forEach((searchTextPart) => {
      url.searchParams.append("searchText", searchTextPart);
    });
    const response: { data: TlfItemIndexReadDto[] } = await axios.get(url.href, {
      signal: controller.signal,
    });
    // Return successful result
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Load search all Tlfs failed", error);
  }
};
